var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4425 6.73369C30.3527 3.64396 26.2431 1.94611 21.8755 1.94611C17.5019 1.94611 13.3982 3.64396 10.3085 6.73369C7.21875 9.82342 5.51489 13.9331 5.51489 18.3007C5.51489 27.1379 13.8722 34.4933 18.3658 38.441C18.9897 38.9929 19.5237 39.4669 19.9556 39.8628C20.4956 40.3668 21.1855 40.6188 21.8755 40.6188C22.5654 40.6188 23.2554 40.3668 23.7893 39.8628C24.2213 39.4669 24.7612 38.9929 25.3852 38.441C29.8728 34.4933 38.2301 27.1379 38.2301 18.3007C38.2301 13.9331 36.5322 9.82342 33.4425 6.73369V6.73369Z",
    fill: "#0E64A9",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0687 10.2141C21.3852 10.0383 21.7412 9.94611 22.1032 9.94611C22.4652 9.94611 22.8212 10.0383 23.1377 10.2141L31.1439 14.6609C31.3099 14.7532 31.4482 14.8882 31.5445 15.0519C31.6407 15.2156 31.6915 15.4021 31.6915 15.592V24.3653C31.6914 24.7453 31.5897 25.1183 31.397 25.4458C31.2042 25.7732 30.9274 26.0431 30.5952 26.2276L23.1377 30.3719C22.8212 30.5476 22.4652 30.6398 22.1032 30.6398C21.7412 30.6398 21.3852 30.5476 21.0687 30.3719L13.6112 26.2276C13.2791 26.0432 13.0024 25.7734 12.8097 25.4462C12.617 25.119 12.5152 24.7462 12.5149 24.3664V15.592C12.5149 15.4021 12.5656 15.2156 12.6619 15.0519C12.7582 14.8882 12.8965 14.7532 13.0625 14.6609L21.0698 10.2141H21.0687Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.309 12.3022L26.8973 17.629V21.3578",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.711 20.6419L18.9071 22.4232",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1032 20.2925V30.9461M12.5149 14.9656L22.1032 20.2925L12.5149 14.9656ZM22.1032 20.2925L31.6915 14.9656L22.1032 20.2925Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3655",
    x: 0.0148926,
    y: 0.446106,
    width: 43.7152,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3655"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3655",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.8877869cd53a0114aafc7f64f105355a.svg";
export { ForwardRef as ReactComponent };